import { ASSET_URL, DEFAULT_LOGO_HEIGHT, DEFAULT_LOGO_WIDTH } from '~/constants';
import { useActiveChannel, usePartnerConfig } from '~/context/PartnerConfigContext';
import { MarketplaceChannel, MarketplacePartner } from '~/types/marketplace';

type LogoProps = {
  partner?: MarketplacePartner;
  channel: MarketplaceChannel | null;
  type?: 'default' | 'minimal';
  width?: number;
};

export const Logo = ({ partner: _partner, channel, type = 'default', width }: LogoProps) => {
  const config = usePartnerConfig();
  const activeChannel = useActiveChannel();
  const partnerId = config?.id;

  // Brighte is the platform owner, not a white-label partner — its branding is
  // handled by BrighteLogo and never shown via this component.
  if (!partnerId || partnerId === 'brighte') {
    return null;
  }

  const suffix = type === 'minimal' ? 'icon-logo' : 'logo';
  const href = config?.configuration?.partnerWebsiteUrl ?? undefined;
  const altText = `${config?.name ?? channel ?? 'Partner'} logo`;

  // Some channels have their own logo asset (there's no minimal/icon variant
  // per channel, so that path always stays on the partner-keyed asset).
  const src =
    type === 'default' && activeChannel?.hasChannelLogo
      ? `${ASSET_URL}/partners/${activeChannel.slug}-${suffix}.svg`
      : `${ASSET_URL}/partners/${partnerId}-${suffix}.svg`;

  const logoImage = <img src={src} alt={altText} height={DEFAULT_LOGO_HEIGHT} width={width ?? DEFAULT_LOGO_WIDTH} />;

  // Without a destination URL the logo must not be clickable, so render the bare
  // image instead of a dead anchor.
  if (!href) {
    return logoImage;
  }

  return (
    <a target="_blank" rel="noreferrer" href={href}>
      {logoImage}
    </a>
  );
};
